// extracted by mini-css-extract-plugin
export default {"cell-control":"cell-control__gm3mU"};